// extracted by mini-css-extract-plugin
export default {"container":"MessageLoader_container__wnRX3","message":"MessageLoader_message__iOCDb"};